export const ASSIGNED = [2, 3, 4, 5, 7];
export const UNASSIGNED = [1];
export const COMPLETED = [6, 8];

export const DEFAULT_PROJECT_FILTER = {
  searchText: "",
  projectNumber: "",
  projectType: [],
  complexity: [],
  status: [],
  startDate: "",
  endDate: ""
};

export const DEFAULT_ERROR_STATUS = { id: 1, name: "Error free" };
export const DEFAULT_PROJECT_STATUS = { id: 1, name: "Unassigned" };

export const UNASSIGNED_PROJECTS_PATH = "/projects/unassigned";



// WEBPACK FOOTER //
// ./src/config/projectSettings.js